import { useState, useRef, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
const Header = ({ toggleSidebar }) => {
 const location = useLocation().pathname;
 const email = localStorage.getItem("email");
 const [dropdownOpen, setDropdownOpen] = useState(false);
 const dropdownRef = useRef();

 useEffect(() => {
  document.addEventListener("mousedown", handleClickOutside);
  return () => document.removeEventListener("mousedown", handleClickOutside);
 }, []);
 const handleLogout = () => {
  localStorage.clear();
  window.location.href = "/";
 };
 const handleClickOutside = (event) => {
  if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
   setDropdownOpen(false);
  }
 };

 return (
  <>
   <nav
    className={`navbar default-layout-navbar col-lg-12 col-12 p-0 fixed-top d-flex flex-row ${
     location === "/" || location === "/forgot-password" ? "d-none" : ""
    }`}
   >
    <div className="navbar-brand-wrapper d-flex align-items-center">
     <Link className="navbar-brand brand-logo" to="/dashboard">
      <img src={`/logo.webp`} alt="logo" className="logo-dark" />
     </Link>
    </div>

    
    <div className=" d-flex align-items-center flex-grow-1">
   <div className="d-none d-sm-flex justify-content-center align-items-center w-100">
  <h5 className="mb-0 font-weight-medium text-center">
    Welcome to the Kekee Impex - Admin Panel
  </h5>
</div>


    <ul className="navbar-nav navbar-nav-right ml-auto mr-3">
  <li
    className="nav-item dropdown d-none d-xl-inline-flex user-dropdown "
    ref={dropdownRef}
  >
    <span
      className="nav-link d-flex align-items-center "
      style={{ cursor: "pointer" }}
      onClick={() => setDropdownOpen(!dropdownOpen)}
    >
      
      <img
        className="img-xs rounded-circle"
        src={`${process.env.PUBLIC_URL}/favicon.png`}
        alt="Profile"
        style={{ objectFit: "contain" }}
      />
      
            <i
        className="fa fa-angle-down ml-1"
        style={{ fontSize: "0.90rem", lineHeight: 1 }}
      />
    </span>

    {dropdownOpen && (
      <div
        className="dropdown-menu dropdown-menu-right navbar-dropdown show"
        aria-labelledby="UserDropdown"
        style={{ position: "absolute", top: "100%", right: 0, zIndex: 1000 }}
      >
        <div className="dropdown-header text-center">
          <img
            className="img-md rounded-circle"
            src={`${process.env.PUBLIC_URL}/favicon.png`}
            style={{ width: "50px", height: "50px" }}
            alt="Profile"
          />
          <p className="mb-1 text-dark font-weight-bold">Kekee</p>
          <p className="font-weight-light text-muted mb-0">{email}</p>
        </div>

        <Link
          className="dropdown-item d-flex align-items-center"
          to="/change-password"
        >
          <i className="fa-regular fa-keyboard mr-3" />
          <span className="text-dark">Change Password</span>
        </Link>

        <Link
          className="dropdown-item d-flex align-items-center"
          to="/profile"
        >
          <i className="far fa-user mr-3 text-dark" />
          <span className="text-dark">My Profile</span>
        </Link>

        <span
          className="dropdown-item d-flex align-items-center"
          onClick={handleLogout}
          style={{ cursor: "pointer" }}
        >
          <i className="fa fa-sign-out-alt text-dark mr-2" />
          <span className="text-dark">Sign Out</span>
        </span>
      </div>
    )}
  </li>
</ul>

     <button
      className="navbar-toggler navbar-toggler-right d-lg-none align-self-center"
      type="button"
      data-toggle="offcanvas"
      onClick={toggleSidebar}
     >
      <i className="fa-solid fa-bars"></i>
     </button>
    </div>
   </nav>
  </>
 );
};

export default Header;
